import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import usePublicAppConfig from '../../hooks/usePublicAppConfig';
import { getPlacementFromPathname } from '../../helper/appInformationPlacement';
import BlockLoading from '../BlockLoading';
import MaintenancePage from '../../containers/MaintenancePage';

const getMaintenanceMessage = (item) =>
	String(item?.description || item?.content || item?.title || '').trim();

const AppMaintenanceGuard = ({ children }) => {
	const { pathname } = useLocation();
	const publicAppConfig = usePublicAppConfig();
	const currentPlacement = useMemo(
		() => getPlacementFromPathname(pathname),
		[pathname]
	);

	const maintenanceItem = useMemo(() => {
		if (!currentPlacement) return null;

		return (publicAppConfig.appInformationItems || []).find((item) => {
			return (
				item?.enabled !== false &&
				item?.informationType === 'ticker' &&
				getMaintenanceMessage(item) &&
				Array.isArray(item?.maintenanceTargets) &&
				item.maintenanceTargets.includes(currentPlacement)
			);
		});
	}, [currentPlacement, publicAppConfig.appInformationItems]);

	if (publicAppConfig.loading) {
		return <BlockLoading />;
	}

	if (maintenanceItem) {
		return <MaintenancePage target={currentPlacement} item={maintenanceItem} />;
	}

	return children;
};

AppMaintenanceGuard.propTypes = {
	children: PropTypes.node.isRequired,
};

export default AppMaintenanceGuard;
